var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('input',_vm._g(_vm._b({class:['form-control', _vm.$style.noClear, _vm.inputClass],attrs:{"type":"search"},domProps:{"value":_vm.value}},'input',{ placeholder: _vm.placeholder, name: _vm.name, ..._vm.$attrs },false),{
      ..._vm.$listeners,
      input: ($event) => _vm.$emit('input', $event.target.value)
    })),(_vm.showClear || _vm.value)?_c('button',{class:['close', _vm.$style.clearBtn],attrs:{"type":"button"},on:{"click":function($event){_vm.$listeners.clear
      ? _vm.$listeners.clear()
      : (_vm.$listeners.change ? _vm.$listeners.change({ target: { value: '' }}) : _vm.$listeners.input(''))}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }